
export enum TravelReqAction {
  VIEW = '1',
  EDIT = '2',
  DELETE = '3',
}

export enum TravelRequestLineItemSection {          
  MODE_OF_JOURNEY = 'modeOfJourneyForm',
  ACCOMMODATION_TYPE = 'accommodationForm',
  EXPENSE_CLAIM = 'expenseClaimForm',
  OFFICE_EXPENSE_CLAIM = 'officeExpenseClaimForm',
  PER_DIEM = 'perDiemForm',
  PER_KM = 'perKmForm',
  HEADER = 'header',
  ATTACHMENTS = 'attachments',
}

export enum TravelAttachmentReadSource {
  HEADER = 'HEADER',
  MODE_OF_JOURNEY = 'MODE_OF_JOURNEY',
  ACCOMMODATION = 'ACCOMMODATION',
  EXPENSE = 'EXPENSE',
  PER_DIEM = 'PER_DIEM',
  PER_KM = 'PER_KM',
  GALLERY = 'GALLERY',
}

export enum TravelRequestHeaderFormKeys {
  EMPLOYEE = 'employee',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  PURPOSE_OF_TRAVEL = 'purposeOfTravel',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  FROM_COUNTRY = 'fromCountry',
  FROM_CITY = 'fromCity',
  TO_COUNTRY = 'toCountry',
  TO_CITY = 'toCity',
  BUDGET = 'budget',
  BUDGET_CURRENCY = 'budgetCurrency',
  ADVANCE_AMOUNT = 'advanceAmount',
  ADVANCE_AMOUNT_CURRENCY = 'advanceAmountCurrency',
  HANDSET_MODEL = 'handsetModel',
  DATE_OF_PURCHASE = 'dateOfPurchase',
  HANDSET_IMEI = 'imeiNo',
  COST = 'cost',
  REMARKS = 'remarks',
  COST_CURRENCY = 'costCurrency',
  COST_CENTER = 'costCenter',
  CUSTOMER = 'customer',
  BILL_TO_CUSTOMER = 'billToCustomer',
  MONTH = 'month',
}

export enum TravelRequestReportRowKeys {
  SERIAL_NO = 'serialNo',
  ID = 'id',
  REQUEST_NO = 'requestNo',
  TEMP_REQUEST_NO = 'tempRequestNo',
  EMPLOYEE_CODE = 'employeeCode',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  PURPOSE_OF_TRAVEL = 'purposeOfTravel',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  COST_CENTER = 'costCenter',
  PROJECT = 'project',
  FROM_COUNTRY = 'fromCountry',
  FROM_CITY = 'fromCity',
  TO_COUNTRY = 'toCountry',
  TO_CITY = 'toCity',
  BUDGET = 'budget',
  BUDGET_CURRENCY = 'budgetCurrency',
  ADVANCE_AMOUNT = 'advanceAmount',
  ADVANCE_AMOUNT_CURRENCY = 'advanceAmountCurrency',
  CREATED_BY_USER = 'createdByUser',
  SUBMISSION_STATUS = 'submissionStatus',
  CURRENT_APPROVAL_LEVEL = 'currentApprovalLevel',
  APPROVAL_STATUS = 'approvalStatus',
  LIFECYCLE_STATUS = 'lifecycleStatus',
  ACTION = 'action',
  IS_FINAL_APPROVED = 'isFinalApproved',
  HAS_ATTACHMENT = 'hasAttachment',
}
export enum TravelRequestApprovalRowKeys {
  SERIAL_NO = 'serialNo',
  ID = 'id',
  REQUEST_NO = 'requestNo',
  TEMP_REQUEST_NO = 'tempRequestNo',
  EMPLOYEE_CODE = 'employeeCode',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  PURPOSE_OF_TRAVEL = 'purposeOfTravel',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  COST_CENTER = 'costCenter',
  PROJECT = 'project',
  FROM_COUNTRY = 'fromCountry',
  FROM_CITY = 'fromCity',
  TO_COUNTRY = 'toCountry',
  TO_CITY = 'toCity',
  BUDGET = 'budget',
  BUDGET_CURRENCY = 'budgetCurrency',
  ADVANCE_AMOUNT = 'advanceAmount',
  ADVANCE_AMOUNT_CURRENCY = 'advanceAmountCurrency',
  CREATED_BY_USER = 'createdByUser',
  SUBMISSION_STATUS = 'submissionStatus',
  CURRENT_APPROVAL_LEVEL = 'currentApprovalLevel',
  APPROVAL_STATUS = 'approvalStatus',
  ACTION = 'action',
  IS_FINAL_APPROVED = 'isClaimFinalApproved',
  TOTAL_AMOUNT = 'totalAmount',
  SUBMITTED_ON = 'submittedOn',
  FINAL_APPROVED_TIMESTAMP = 'claimFinalApprovedTimeStamp',
  REQUEST_FINAL_APPROVED_TIMESTAMP = 'requestFinalApprovedTimeStamp',
  HAS_ATTACHMENT = 'hasAttachment',
  APPROVED_AMOUNT = 'approvedAmount',
  EMPLOYEE = 'employee',
  TOUR_FINAL_APPROVED_BY = 'tourFinalApprovedBy',
  LAST_PUSHED_TO_SAP_AT = 'lastPushedToSapAt',
  CREATED_AT = 'createdAt',
  SAP_DOCUMENT_NUMBER = 'sapDocumentNumber',
  SAP_SCROLL_NO = 'sapScrollNo',
  SAP_RESPONSE = 'sapResponse',
  SAP_RESPONSE_MESSAGE = 'sapResponseMessage',
}

export enum PerDimMappingTableKeys {
  SERIAL_NO = 'serialNo',
  CITY = 'city',
  STATE = 'state',
  DESIGNATION = 'designation',
  AMOUNT = 'amount',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  REMARKS = 'remarks',
  ACTION = 'action',
}

export enum PerDiemMappingFormKeys {
  DESIGNATION = 'designation',
  CITY = 'city',
  STATE = 'state',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  AMOUNT = 'amount',
  REMARKS = 'remarks',
}

export enum PerKmMappingTableKeys {
  SERIAL_NO = 'serialNo',
  MODE_OF_TRANSPORT = 'modeOfTransport',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  RATE_PER_KM = 'ratePerKm',
  DESIGNATION = 'designation',
  EMPLOYEE_TYPE = 'employeeType',
  GRADE = 'grade',
  REMARKS = 'remarks',
  ACTION = 'action',
}

export enum PerKmMappingFormKeys {
  MODE_OF_TRANSPORT = 'modeOfTransport',
  GRADE = 'grade',
  USER_ID = 'userId',
  MONTHLYLIMIT = 'monthlyLimit',
  RATE_PER_KM = 'ratePerKm',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  AMOUNT = 'amount',
  COMPANY_GROUP = 'companyGroupId',
  COMPANY = 'companyId',
  ATTCHMENTREQUIRED = 'attachmentRequired',
  HAS_NO_LIMIT = 'hasNoLimit',
}

export enum ExpenseTypeAndGlAccountMappingTableKeys {
  SERIAL_NO = 'serialNo',
  EXPENSE_TYPE = 'expenseType',
  GL_ACCOUNT = 'glAccount',
  ACTION = 'action',
}

export enum ExpenseTypeAndGlAccountMappingFormKeys {
  EXPENSE_TYPE = 'expenseType',
  GL_ACCOUNT = 'glAccount',
}

export enum DesignationAndModeOfJourneyMappingTableKeys {
  SERIAL_NO = 'serialNo',
  DESIGNATION = 'designation',
  MODE_OF_JOURNEY = 'modeOfJourney',
  ACTION = 'action',
}

export enum DesignationAndModeOfJourneyMappingFormKeys {
  MODE_OF_JOURNEY = 'modeOfJourney',
  DESIGNATION = 'designation',
}

export enum DesignationAndExpenseTypeMappingTableKeys {
  SERIAL_NO = 'serialNo',
  DESIGNATION = 'designation',
  EMPLOYMENT_TYPE = 'employmentType',
  EMPLOYEE = 'employee',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  EXPENSE_TYPE = 'expenseType',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  ACTION = 'action',
  GRADE = 'grade',
}

export enum DesignationAndExpenseTypeMappingFormKeys {
  DESIGNATION = 'designation',
  EMPLOYMENT_TYPE = 'employmentType',
  GRADE = 'grade',
  EMPLOYEE = 'employee',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  EXPENSE_TYPE = 'expenseType',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
}

export enum ExpenseTypeLimitMappingTableKeys {
  SERIAL_NO = 'serialNo',
  DESIGNATION = 'designation',
  EMPLOYMENT_TYPE = 'employmentType',
  GRADE = 'grade',
  EMPLOYEE = 'employee',
  CLAIM_LIMIT_TYPE = 'claimLimitType',
  EXPENSE_TYPE = 'expenseType',
  AMOUNT = 'amount',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  ACTION = 'action',
}

export enum ExpenseTypeLimitMappingFormKeys {
  COMPANY_GROUP = 'companyGroupId',
  COMPANY = 'companyId',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  GRADE = 'grade',
  EMPLOYEE = 'userId',
  CLAIM_LIMIT_TYPE = 'claimLimitType',
  EXPENSE_TYPE = 'expenseType',
  AMOUNT = 'amount',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  ATTCHMENTREQUIRED = 'attachmentRequired',
  HAS_NO_LIMIT = 'hasNoLimit',
}

export enum ClaimLimitType {
  PER_QUARTER = 'PER_QUARTER',
  PER_MONTH = 'PER_MONTH',
  PER_YEAR = 'PER_YEAR',
  PER_DAY = 'PER_DAY',
}

export enum AntiPatternErrorType {
  WARNING = 'WARNING',
  INFO = 'INFO',
  ERROR = 'ERROR',
}

export enum ExpenseAntiPatternMappingFormKeys {
  COMPANY_GROUP = 'companyGroupId',
  COMPANY = 'companyId',
  CLAIM_CATEGORY = 'claimCategoryId',
  CLAIM_SUB_CATEGORY = 'claimSubCategoryId',
  ACCOMMODATION_TYPE = 'accommodationTypeId',
  MODE_OF_JOURNEY = 'modeOfJourneyId',
  MODE_OF_TRANSPORT = 'modeOfTransportId',
  EXPENSE_TYPE = 'expenseTypeId',
  COMPLEMENT_EXPENSE_TYPE = 'complementExpenseTypeId',
  ERROR_TYPE = 'errorType',
  MESSAGE = 'message',
}

export enum DesignationAndAccomodationMappingTableKeys {
  SERIAL_NO = 'serialNo',
  DESIGNATION = 'designation',
  ACCOMODATION_TYPE = 'accomodationType',
  ACTION = 'action',
}

export enum DesignationAndAccomodationMappingFormKeys {
  DESIGNATION = 'designation',
  ACCOMMODATION_TYPE = 'accommodationType',
}

export enum DepartmentAndCostCenterMappingTableKeys {
  SERIAL_NO = 'serialNo',
  DEPARTMENT = 'department',
  COST_CENTER = 'costCenter',
  ACTION = 'action',
}

export enum DepartmentAndCostCenterMappingFormKeys {
  // DEPARTMENT = 'department',
  // COST_CENTER = 'costCenter',
  COMPANY_GROUP = 'companyGroupId',
  COMPANY = 'companyId',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  EXPENSE_TYPE = 'expenseType',
  GL_ACCOUNT = 'glAccount',
}

export enum DepartmentAndGlCodeMappingTableKeys {
  SERIAL_NO = 'serialNo',
  DEPARTMENT = 'department', 
  GL_CODE = 'glCode',
  ACTION = 'action',
}

export enum DepartmentAndGlCodeMappingFormKeys {
  DEPARTMENT = 'department',
  GL_CODE = 'glCode',
}

export enum ClaimAndSubClaimMappingTableKeys {
  SERIAL_NO = 'serialNo',
  CLAIM_CATEGORY = 'claimCategoryId',
  CLAIM_SUB_CATEGORY = 'claimSubCategoryId',        
  ACTION = 'action',
}

export enum ClaimAndSubClaimMappingFormKeys {
  CLAIM_CATEGORY = 'claimCategoryId',
  CLAIM_SUB_CATEGORY = 'claimSubCategoryId',
  COMPANY_GROUP = 'companyGroupId',
  COMPANY = 'companyId',
}

export enum ExchangeRateMappingFormKeys {
  SOURCE_CURRENCY = 'sourceCurrencyId',
  TARGET_CURRENCY = 'targetCurrencyId',
  RATE_PER_UNIT_IN_TARGET = 'ratePerUnitInTarget',
  RATE_DATE = 'rateDate',
}

// Enum for column keys
export enum ETaxCodeColumns {
  NAME = 'name',
  DESCRIPTION = 'description',
  ERPCODE = 'erpCode',
  CODE = 'code',
  CGST = 'cgst',
  SGST = 'sgst',
  IGST = 'igst',
  UGST = 'ugst',
  COUNTRY = 'countryId',
  STATE = 'stateId',
  HSN_CODE_ID = 'hsnCodeId',
  TAX_PERCENTAGE = 'taxPercentage',
  VALID_FROM = 'validFrom',
  VALID_TO = 'validTo',
  DISTRIBUTION_CHANNEL = 'distributionChannelId'
}

export enum CountryAndCityMappingTableKeys {
  SERIAL_NO = 'serialNo',
  COUNTRY = 'country',
  CITY = 'city',
  STATE = 'state',
  ACTION = 'action',
}

export enum CountryAndCityMappingFormKeys {
  COUNTRY = 'country',
  CITY = 'city',
}

export enum ModeOfJourneyFormKeys {
  MODE_OF_JOURNEY = 'modeOfJourney',
  FROM_DATE = 'fromDate',
  FROM_TIME = 'fromTime',
  FROM_COUNTRY = 'fromCountry',
  FROM_CITY = 'fromCity',
  TO_DATE = 'toDate',
  TO_TIME = 'toTime',
  TO_COUNTRY = 'toCountry',
  TO_CITY = 'toCity',
  REMARKS = 'remarks',
}
export enum HandsetMappingFormKeys {
  USER_ID = 'userId',
  LAST_PURCHASE_DATE = 'lastPurchaseDate',
  AMOUNT = 'amount',
  CURRENCY = 'limitCurrency',
  LIMIT = 'limit',
  REMARKS = 'remarks',
}
export enum ConveyanceLimitMappingFormKeys {
  COMPANY_GROUP = 'companyGroupId',
  COMPANY = 'companyId',
  USER_ID = 'userId',
  GRADE = 'gradeId',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  FREQUENCY = 'frequencyInDays',
  AMOUNT = 'amount',
  HAS_NO_LIMIT = 'hasNoLimit',
}
export enum ConveyanceLimitMappingTableKeys {
  SERIAL_NO = 'serialNo',
  GRADE = 'gradeId',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  FREQUENCY = 'frequencyInDays',
  AMOUNT = 'amount',
  // HAS_NO_LIMIT = 'hasNoLimit',
  ACTION = 'action',
}

export enum AccommodationTypeFormKeys {
  ACCOMMODATION_TYPE = 'accommodationType',
  CHECK_IN_DATE = 'checkInDate',
  CHECK_OUT_DATE = 'checkOutDate',
  CHECK_IN_TIME = 'checkInTime',
  CHECK_OUT_TIME = 'checkOutTime',
  COUNTRY = 'country',
  CITY = 'city',
  REMARKS = 'remarks',
}

export enum ExpenseClaimFormKey {
  EXPENSE_TYPE = 'expenseType',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  FROM_COUNTRY = 'fromCountry',
  FROM_CITY = 'fromCity',
  TO_COUNTRY = 'toCountry',
  TO_CITY = 'toCity',
  VENDOR = 'vendor',
  VENDOR_GSTIN = 'vendorGSTIN',
  VENDOR_STATE = 'vendorState',
  VENDOR_NAME = 'vendorName',
  BUSINESS_PURPOSE = 'businessPurpose',
  PAYMENT_METHOD = 'paymentMethod',
  AMOUNT = 'amount',
  CURRENCY = 'currency',
  IS_PERSONAL_EXPENSE = 'isPersonalExpense',
  INVOICE_NO = 'invoiceNo',
  INVOICE_DATE = 'invoiceDate',
  PNR_NO = 'pnrNo',
  GL_ACCOUNT = 'glAccount',
  GST_CODE = 'gstCode',
  MODE_OF_TRANSPORT = 'modeOfTransport',
  COST_CENTER = 'costCenter',
  VEHICLE_NO = 'vehicleNo',
  LAN_NO = 'lanNo',
  CUSTOMER = 'customer',
  DSA_CODE = 'dsaCode',
  REMARKS = 'remarks',
  HOTEL_NAME = 'hotelName',
  HOTEL_STATE = 'hotelState',
  HOTEL_CITY = 'hotelCity',
  HOTEL_COUNTRY = 'hotelCountry',
  HOTEL_ADDRESS = 'hotelAddress',
  HOTEL_ADDRESS_LAT = 'hotelAddressLat',
  HOTEL_ADDRESS_LNG = 'hotelAddressLng',
  HOTEL_PHONE_NUMBER = 'hotelPhoneNumber',
  GST_IN = 'gstIn',
  CANCELLATION_REASON = 'cancellationReason',
  CANCELLATION_CHAGRES = 'cancellationCharges',
  HAS_REFUND = 'hasRefund',
  IS_CANCELLATION = 'isCancellation',
  BILL_TO_CUSTOMER = 'billToCustomer',
  NO_OF_DAYS = 'noOfDays',
  IS_EXCEPTION = 'isException',
}

export enum PerDiemFormKeys {
  CITY = 'city',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  NO_OF_DAYS = 'noOfDays',
  RATE = 'rate',
  TOTAL = 'total',
  REMARKS = 'remarks',
}

export enum PerKmClaimFormKeys {
  MODE_OF_TRANSPORT = 'modeOfTransport',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  SOURCE = 'source',
  DESTINATION = 'destination',
  FROM_METER = 'fromMeter',
  TO_METER = 'toMeter',
  DISTANCE_IN_KM = 'distanceInKm',
  RATE_PER_KM = 'ratePerKm',
  TOTAL = 'total',
  APPROVED_AMOUNT = 'approvedAmount',
  REMARKS = 'remarks',
  SOURCE_LAT = 'sourceLat',
  SOURCE_LNG = 'sourceLng',
  DESTINATION_LAT = 'destinationLat',
  DESTINATION_LNG = 'destinationLng',
}

export enum TravelRequestApprovalType {
  DEFAULT = 'DEFAULT',
  EXCEPTION = 'EXCEPTION',
}

export enum ReviewType {
  SKIP = 'SKIP',
  RESET = 'RESET',
}

export enum ReportListAction {
  VIEW = '1',
  PUSH = '2',
}

export enum ClaimRequestType {
  TRAVEL = 'tour',
  HANDSET = 'handset',
  CONVEYANCE = 'conveyance',
  CLAIM = 'directClaim',
}

export enum TourRequestType {
  REQUEST = 'REQUEST',
  CLAIM = 'CLAIM',
}

export enum FilterFormKeys {
  EMPLOYEE = 'employee',
  CLAIM_CATEGORY = 'claimCategory',
  CLAIM_SUB_CATEGORY = 'claimSubCategory',
  IS_CLAIM_FINAL_APPROVED = 'isClaimFinalApproved',
  SUBMITTED_ON_FROM = 'submittedOnFrom',
  SUBMITTED_ON_TO = 'submittedOnTo',
  CLAIM_FINAL_APPROVED_TIME_FROM = 'claimFinalApprovedTimeFrom',
  CLAIM_FINAL_APPROVED_TIME_TO = 'claimFinalApprovedTimeTo',
  REQUEST_FINAL_APPROVED_TIME_FROM = 'requestFinalApprovedTimeFrom',
  REQUEST_FINAL_APPROVED_TIME_TO = 'requestFinalApprovedTimeTo',
  REQUEST_SUBMITTED_FOR_CLAIM_ON_FROM = 'requestSubmittedForClaimOnFrom',
  REQUEST_SUBMITTED_FOR_CLAIM_ON_TO = 'requestSubmittedForClaimOnTo',
  APPROVAL_STATUS = 'approvalStatus',
  SUBMISSION_STATUS = 'submissionStatus',
  CURRENT_APPROVER_ID = 'currentApproverId',
  IS_REQUEST_FINAL_APPROVED = 'isRequestFinalApproved',
  REQUEST_FINAL_APPROVED_BY_ID = 'requestFinalApprovedById',
  FINAL_APPROVED_BY_ID = 'finalApprovedById',
}

export enum TravelRequestSortByOptions {
  AMOUNT_DESC = 'amountDesc',
  AMOUNT_ASC = 'amountAsc',
  CREATED_DATE_DESC = 'createdDateDesc',
  CREATED_DATE_ASC = 'createdDateAsc',
  SUBMITTED_DATE_DESC = 'submittedDateDesc',
  SUBMITTED_DATE_ASC = 'submittedDateAsc',
  TOUR_SUBMITTED_FOR_CLAIM_DESC = 'tourSubmittedForClaimDesc',
  TOUR_SUBMITTED_FOR_CLAIM_ASC = 'tourSubmittedForClaimAsc',
  CLAIM_FINAL_APPROVED_ON_ASC = 'claimFinalApprovedOnAsc',
  CLAIM_FINAL_APPROVED_ON_DESC = 'claimFinalApprovedOnDesc',
  UPDATED_DATE_ASC = 'updatedDateAsc',
  UPDATED_DATE_DESC = 'updatedDateDesc',
  TOUR_APPROVED_ON_ASC = 'tourApprovedOnAsc',
  TOUR_APPROVED_ON_DESC = 'tourApprovedOnDesc',
}

export enum TravelRequestFilterStorageKeys {
  REPORT_FILTERS = 'travelReqReportFilters',
  HOME_FILTERS = 'travelReqFilters',
  APPROVAL_FILTERS = 'travelReqApprovalFilters',
}

export enum TravelRequestMarkAsPaidStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}
